<template>
  <input class="file-upload" type="file" v-on:tap.stop v-on:change="onFileChange" accept="image/*" />
</template>
<script>
export default {
  name: 'RdsFileUploader',
  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFile(files[0]);
    },
    createFile(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.$emit('fileUploaded', e.target.result);
        console.log('emit', 'fileUploaded');
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>
<style lang="scss" scoped>
.file-upload {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2;
  left: 0;
  top: 0;
}
</style>
